var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18next from 'i18next';
var BaseOneServiceI18n = /** @class */ (function () {
    function BaseOneServiceI18n() {
        this.client = i18next.createInstance();
    }
    BaseOneServiceI18n.prototype.init = function (opts) {
        var _this = this;
        opts.plugins &&
            opts.plugins.forEach(function (p) {
                _this.client.use(p);
            });
        return this.client.init(__assign(__assign({ load: 'currentOnly', fallbackLng: false, saveMissing: true, missingKeyHandler: function (lng, ns, key, fallbackValue) {
                console.warn('MISSING TRANSLATION: ', { languages: lng, namespace: ns, key: key, fallbackValue: fallbackValue });
            } }, opts.init), { initImmediate: false }));
    };
    BaseOneServiceI18n.prototype.getClient = function () {
        return this.client;
    };
    BaseOneServiceI18n.prototype.get = function (keys, opts) {
        return this.client.t(keys, opts);
    };
    BaseOneServiceI18n.prototype.exists = function (key) {
        return this.client.exists(key);
    };
    return BaseOneServiceI18n;
}());
export { BaseOneServiceI18n };
